export interface SliceOverflowPillItemsParams<T> {
  isExpanded: boolean;
  items: T[];
  visibleItemIndexes: number[];
}

export interface OverflowPillSlices<T> {
  collapsedItems: T[];
  expandedInlineItems: T[];
  popoverItems: T[];
  popoverOverflowCount: number;
  showExpandControl: boolean;
  showPopoverControl: boolean;
  showShowLessControl: boolean;
  visibleItems: T[];
}

export const sliceOverflowPillItems = <T>({
  isExpanded,
  items,
  visibleItemIndexes,
}: SliceOverflowPillItemsParams<T>): OverflowPillSlices<T> => {
  const visibleIndexSet = new Set(visibleItemIndexes);
  const visibleItems = visibleItemIndexes
    .map(index => items[index])
    .filter((item): item is T => item !== undefined);
  const popoverItems = items.filter((_, index) => !visibleIndexSet.has(index));
  const popoverOverflowCount = popoverItems.length;
  const showExpandControl = items.length > visibleItemIndexes.length;
  const showPopoverControl = isExpanded && popoverOverflowCount > 0;
  const showShowLessControl = isExpanded;

  return {
    collapsedItems: visibleItems,
    expandedInlineItems: visibleItems,
    popoverItems,
    popoverOverflowCount,
    showExpandControl,
    showPopoverControl,
    showShowLessControl,
    visibleItems,
  };
};
